import React from "react";
import Admin from "us.collection.admin";
import { Loader, WithFeatureFlag } from "us.common/components";
import { FeatureFlags } from "us.common/constants";
import { withRouter } from "us.common/wIthRouter";

interface ICntNonProductionDaysCopyFromPreviousYear {}

const Cnt_NonProductionDaysCopyFromPreviousYear: React.FC<ICntNonProductionDaysCopyFromPreviousYear> =
  (props) => {
    return (
      <WithFeatureFlag
        flag={FeatureFlags.NON_PRODUCTION_DAYS}
        children={
          <Admin.Components.NonProductionDays.CopyFromPreviousYear {...props} />
        }
        loader={<Loader />}
      />
    );
  };

export default withRouter(Cnt_NonProductionDaysCopyFromPreviousYear);
